<template>
    <div class="shop_area" v-if="$root.defaultShop == ''">

        <div class="shoplist_pane_top_location_text" v-if="($root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
            <div class="location_text_1">{{label['search_address_text']}}:</div>
            <div class="location_text_2" @click="$router.push('/')">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
        </div>
       

        <div class="full_content_area shop_content_area" v-if="shopList.length == 0">

            <div class="shop_display_area">
                <!--            
                <div class="shop_back_area display_responsive">
                    <div class="shop_back_btn" @click="$router.replace('/');"></div>
                </div>                
                -->

                <div class="shop_not_found_div">
                    {{label["shop_list_shop_not_found"]}}
                </div>
            </div>
        </div>

        <div class="full_content_area shop_content_area" v-if="shopList.length > 0">

            <div class="order_type_main_area" style="display:none;">
                <div class="order_type_area">
                    <div class="order_type_div delivery select">
                        <div class="order_type_icon"></div>
                        <div class="order_type_text">送遞</div>
                    </div>

                    <div class="order_type_div takeaway">
                        <div class="order_type_icon"></div>
                        <div class="order_type_text">外賣自取</div>
                    </div>

                    <div class="order_type_div shop">
                        <div class="order_type_icon"></div>
                        <div class="order_type_text">商店</div>
                    </div>
                </div>
            </div>



            <div class="shop_display_area" v-if="myListShopDisplay.length > 0">
                <!--
                <div class="shop_back_area display_responsive">
                    <div class="shop_back_btn" @click="$router.replace('/');"></div>
                </div>
                -->

                <div class="title_area">{{label['shop_like_shop_header_text']}}</div>
                <div class="shop_list_area">

                    <div class="shop_list_div"
                         v-for="(s,index) in myListShopDisplay.filter(s2 => (s2.visible == 'y'))"
                         :key="index"
                         :class="{ shop_like: likeShopCheck(s), not_open: (!s.inOnline || !s.isOpen) }">

                        <div class="shop_message_div" v-if="s['shop_list_message'+ getItemSubfix()] != ''">{{s['shop_list_message'+ getItemSubfix()]}}</div>
                        <div class="shop_image_outer_div" @click="selectShop(s)">
                            <div class="shop_image_inner_div">
                                <img :src="getShopImage(s)" loading="lazy" :onerror="'this.onerror=null;this.src=\'/files/images/shop_image/default_shop.png\';'" align="absmiddle" />
                            </div>
                            <div class="shop_image_inner_div" v-if="(!s.inOnline || !s.isOpen)" v-html="getShopNotAvailableText(s)"></div>
                        </div>
                        <div class="shop_name_area">
                            <div class="shop_name_div" @click="selectShop(s)">
                                {{ s["name" + getItemSubfix()] }}
                            </div>
                            <div class="shop_like_div" @click="likeShopClick(s)">
                            </div>
                        </div>
                        <div class="shop_desc_area">
                            <div class="shop_desc_div">{{ s["desc" + getItemSubfix()] }}</div>
                            <div class="shop_sub_desc_div">
                                <div class="sub_desc_text1">{{s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()]}}</div>
                                <div class="sub_desc_text2"><span v-if="s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()] != ''">．</span>{{s['distance']}}{{label['shop_list_km_label']}}</div>
                            </div>
                        </div>
                        <div class="shop_desc_area" v-if="info.order_temp_info.order_time == 'asap'">
                            <div class="shop_readyTime_div" v-if="s['readyTime'] != ''">{{label['order_asap_estimate_time_label_about']}} {{ s["quoteTime"] }} {{label['order_asap_estimate_time_label_min']}}</div>
                        </div>

                    </div>

                </div>
                <!-- shop_list_area end -->

            </div>
            <!-- shop_display_area end -->


            <div class="shop_display_area">

                <div class="title_area">{{label['shop_near_shop_header_text']}}</div>
                <div class="shop_list_area">

                    <div class="shop_list_div"
                         v-for="(s,index) in shopList.filter(s2 => (s2.visible == 'y'))"
                         :key="index"
                         :class="{ shop_like: likeShopCheck(s), not_open: (!s.inOnline || !s.isOpen) }">

                        <div class="shop_message_div" v-if="s['shop_list_message'+ getItemSubfix()] != ''">{{s['shop_list_message'+ getItemSubfix()]}}</div>
                        <div class="shop_image_outer_div" @click="selectShop(s)">
                            <div class="shop_image_inner_div">
                                <img :src="getShopImage(s)" loading="lazy" :onerror="'this.onerror=null;this.src=\'/files/images/shop_image/default_shop.png\';'" align="absmiddle" />
                            </div>
                            <div class="shop_image_inner_div" v-if="(!s.inOnline || !s.isOpen)" v-html="getShopNotAvailableText(s)"></div>
                        </div>
                        <div class="shop_name_area">
                            <div class="shop_name_div" @click="selectShop(s)">
                                {{ s["name" + getItemSubfix()] }}
                            </div>
                            <div class="shop_like_div" @click="likeShopClick(s)">
                            </div>
                        </div>
                        <!--
                        <div class="shop_desc_area">
                            <div class="shop_desc_div">{{ s["desc" + getItemSubfix()] }}</div>
                            <div class="shop_sub_desc_div">
                                <div class="sub_desc_text1">{{s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()]}}</div>
                                <div class="sub_desc_text2"><span v-if="s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()] != ''">．</span>{{s['distance']}}{{label['shop_list_km_label']}}</div>
                            </div>
                        </div>
                        <div class="shop_desc_area" v-if="info.order_temp_info.order_time == 'asap'">
                            <div class="shop_readyTime_div" v-if="s['readyTime'] != ''">{{label['order_asap_estimate_time_label_about']}} {{ s["quoteTime"] }} {{label['order_asap_estimate_time_label_min']}}</div>
                        </div>
                        -->
                        <div class="shop_desc_area">
                            <div class="shop_desc_div">{{label['order_asap_estimate_time_label_about']}} {{ s["quoteTime"] }} {{label['order_asap_estimate_time_label_min']}}</div>
                            <div class="shop_sub_desc_div">
                                <div class="sub_desc_text1">{{s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()]}}</div>
                                <div class="sub_desc_text2"><span v-if="s['shop_list_'+ $root.getCurrentOrderType +'_message'+ getItemSubfix()] != ''">．</span>{{s['distance']}}{{label['shop_list_km_label']}}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- shop_list_area end -->

            </div>
            <!-- shop_display_area end -->


        </div>
    </div>
</template>
 
<script>
    import MiddlePageTopMenuBar from "../components/MiddlePageTopMenuBar.vue";

    export default {
        data() {
            return {
                shopList: [],
                showShopStatus: true,
                showShopDistance: true,
                currentLocation: undefined,
                currentShop: undefined,
                quoteTimeList: [],

                pickupTime: "",
                timer: -1,

                myLikeShop: [],
                myListShopDisplay:[]
            };
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            cart() {
                return this.$root.cart;
            }
        },
        components: { MiddlePageTopMenuBar },
        created() {
            var app = this;
            app.info.loading = true;

            // prevent cannot scroll when loading the page
            app.$root.setBodyOverflow(false);
            app.info.itemMenuDetailsOpen = false;

            // check have brand or not
            app.$root.initSelectBrand();
            app.$root.unloadBrandBanner();

            app.$root.setGoBackAction(this.goBack);

            app.$root.getCurrentPathName();
            
            app.getInitData();

        },
        destroyed() {
            this.$root.setGoBackAction();
            //this.$root.setShowTopBrandDesc(false);
        },
        methods: {
            getShopImage(shop) {
                return this.$root.getShopImage(shop);
                //return "/files/images/shop_image/default_shop.png";
            },
            getShopNotAvailableText(s) {
                if (!s.isOnline) {
                    return this.label['shop_current_not_receive_order_text'];
                }
                else if (!s.isOpen) {
                    return this.label['shop_current_not_available_text'];
                }
                else {
                    return "";
                }
            },
            getInitData() {
                var app = this;
                app.myLikeShop = window.localStorage.getItem("myLikeShop") || "[]";
                var continueShopLoading = false;

                /*
                if (this.$root.info.order_temp_info.order_mode == 'smallPoonChoi') {

                    if (app.cart.shop != null) {
                        app.info.loading = false;
                        app.selectShop(JSON.parse(JSON.stringify(app.cart.shop)));
                    }
                    else {

                        if (app.cart.shopDistrict != "") {
                            var temp_shop = app.$root.AllShopList.filter(s2 => s2.shopType == app.$root.info.order_temp_info.order_mode && s2.shopCode.indexOf("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) > 0 && s2.districtCode == app.cart.shopDistrict);
                            //console.log("temp_shop", temp_shop);
                            $.each(temp_shop, (i, s) => {
                                s.isOnline = true;
                                s.quoteTime = 1;
                                app.shopList.push(s);
                            });
                            continueShopLoading = true;
                        }
                        else {
                            this.$router.replace(`/`);
                        }

                    }

                }
                else {

                    // get shop list start
                    if (app.$root.info.order_setting.skipZeekShopList) {
                        var temp_shop = app.$root.AllShopList.filter(s2 => s2.shopType == app.$root.info.order_temp_info.order_mode && s2.shopCode.indexOf("_" + app.$root.getCurrentOrderTypeShopFilterSubfix) > 0);
                        //console.log("temp_shop 1", temp_shop);
                        $.each(temp_shop, (i, s) => {
                            s.isOnline = true;
                            s.quoteTime = 1;
                            app.shopList.push(s);
                        });
                        continueShopLoading = true;
                    }
                    else {
                        var temp_shop = null;
                        $.each(app.$root.LLShopList, (i, s1) => {
                            //temp_shop = app.$root.AllShopList.filter(s2 => s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode && s2.shopType == app.$root.info.order_temp_info.order_mode);

                            // filter shopCode + 'P' for poonchoi on 20220815
                            temp_shop = app.$root.AllShopList.filter(s2 => (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode || s1.shopCode + 'P' + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode) && s2.shopType == app.$root.info.order_temp_info.order_mode);
                            //console.log("temp_shop 2", temp_shop);
                            if (temp_shop.length > 0) {
                                temp_shop[0].isOnline = s1.isOnline;
                                temp_shop[0].quoteTime = s1.quoteTime;
                                app.shopList.push(temp_shop[0]);
                            }
                        });
                        continueShopLoading = true;
                    }
                    // get shop list end                

                }
                */

                // add CheckOrderModeIsShopping on 20260715 for moving input address select shop to confirmation page 
                if (this.$root.CheckOrderModeIsShopping && this.$root.info.order_temp_info.order_type == 'pickup') {
                    continueShopLoading = true;

                    var temp_shop = null;
                    $.each(app.$root.LLShopList, (i, s1) => {
                        temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode)));
                        //console.log("temp_shop 1", temp_shop);
                        if (temp_shop.length > 0) {
                            //console.log("temp_shop 2", temp_shop);                                
                            temp_shop[0].isOnline = s1.isOnline;
                            //if (temp_shop[0].visible != "y") temp_shop[0].isOnline = false; // not checking visible on tenren
                            temp_shop[0].quoteTime = s1.quoteTime;
                            app.shopList.push(temp_shop[0]);
                        }
                    });
                    //console.log("app.shopList", app.shopList);
                }
                else if (!this.$root.CheckOrderModeIsShopping && this.$root.info.order_temp_info.order_type == 'pickup') {

                    // filter area or disctict if pickup
                    //if (app.cart.shopDistrict != "") {
                    if (app.cart.shopDistrict != "" || (app.$root.info.order_setting.pickupShopAreaFilter && app.cart.shopArea != "")) {
                        continueShopLoading = true;
                        
                        var temp_shop = null;
                        $.each(app.$root.LLShopList, (i, s1) => {
                            
                            if (this.$root.info.order_setting.pickupShopAreaFilter) {
                                //temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode || s1.shopCode + 'P' + "_" + app.$root.getCurrentOrderTypeSubfix == s2.shopCode) && s2.areaCode == app.cart.shopDistrict));
                                temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode || s1.shopCode + 'P' + "_" + app.$root.getCurrentOrderTypeSubfix == s2.shopCode) && (s2.areaCode == app.cart.shopArea || s2.areaCode == ""))); // add shopArea on 20230301
                            }
                            else {
                                temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode || s1.shopCode + 'P' + "_" + app.$root.getCurrentOrderTypeSubfix == s2.shopCode) && (s2.districtCode == app.cart.shopDistrict || s2.districtCode == "")));
                            }
                            //console.log("temp_shop 1", temp_shop);
                            if (temp_shop.length > 0) {
                                //console.log("temp_shop 2", temp_shop);                                
                                temp_shop[0].isOnline = s1.isOnline;
                                //if (temp_shop[0].visible != "y") temp_shop[0].isOnline = false; // not checking visible on tenren
                                temp_shop[0].quoteTime = s1.quoteTime;
                                app.shopList.push(temp_shop[0]);
                            }
                            
                        });
                        //console.log("app.shopList", app.shopList);
                    }
                    else {
                        this.$router.replace(`/`);
                    }
                    
                }
                else {
                    continueShopLoading = true;

                    var temp_shop = null;
                    //console.log("app.$root.LLShopList", JSON.parse(JSON.stringify(app.$root.LLShopList)));
                    $.each(app.$root.LLShopList, (i, s1) => {
                        temp_shop = app.$root.AllShopList.filter(s2 => (s2.shopType == app.$root.info.order_temp_info.order_mode && (s1.shopCode + "_" + app.$root.getCurrentOrderTypeShopFilterSubfix == s2.shopCode || s1.shopCode + 'P' + "_" + app.$root.getCurrentOrderTypeSubfix == s2.shopCode)));
                        //console.log("temp_shop 2", JSON.parse(JSON.stringify(temp_shop)));
                        if (temp_shop.length > 0) {
                            temp_shop[0].isOnline = s1.isOnline;
                            //if (temp_shop[0].visible != "y") temp_shop[0].isOnline = false; // not checking visible on tenren
                            temp_shop[0].quoteTime = s1.quoteTime;
                            //console.log("temp_shop[0]", JSON.parse(JSON.stringify(temp_shop[0])));
                            app.shopList.push(temp_shop[0]);
                        }
                    });
                }


                if (continueShopLoading) {
                    if (app.$root.info.order_setting.autoShopSelect && app.shopList.length > 0) {
                        //app.info.loading = false; // hide for tenren keep loading

                        var select_shop = app.shopList[0];
                        select_shop.isOpen = true;
                        if (!select_shop.isOnline) {
                            select_shop.isOpen = false;
                        }
                        select_shop.isCloseSoon = false;
                        
                        if (app.info.order_temp_info.home_select_shop != "") {
                            // check home select shop
                            app.checkHomeSelectShop();
                        }
                        else if (app.info.order_temp_info.temp_default_shop != "") {
                            // check temp default shop for direct to menu
                            app.checkOrderTempDefaultShop();
                        }
                        else {
                            app.selectShop(select_shop, true);
                        }
                    }
                    else {
                        // get distance start 
                        //this.$root.setShopListDistance(app.shopList); // hide for tenren because loading shoplist in home page
                        // get distance end

                        // get shop isOpen and status start
                        var current_time = moment();
                        $.each(app.shopList, (i, o) => {
                            //o.quoteTime = 1;
                            o.isOpen = false;
                            //o.isOnline = true;
                            o.isCloseSoon = false;
                            o.readyTime = "";

                            //var check_date = app.$root.OrderDateSelect;
                            //var check_date = moment(app.$root.OrderDateSelectRaw).add(o.quoteTime, 'minutes');
                            var check_date = moment(app.$root.OrderDateSelectMenuTime); // use menu time to check businessHours
                            var check_time = check_date.hour() * 100 + check_date.minute();

                            if (o.isOnline) {
                                o.isOpen = app.cart.getShopOpen(o, app.$root.OrderDateSelectIsHoliday, check_date, check_time);
                            }
                            o.status = app.getShopStatus(o);

                            if (o.isOpen) {
                                o.readyTime = moment(current_time).add(o.quoteTime, 'minutes').format("YYYY-MM-DD HH:mm");
                            }
                        });
                        // get shop isOpen and status end

                        // sort shop isOpen then distance start
                        app.shopList = app.shopList.sort(function (a, b) {
                            if (!a.isOpen && b.isOpen) { return 1; }
                            if (a.isOpen && !b.isOpen) { return -1; }
                            if (a.distance > b.distance) { return 1; }
                            if (a.distance < b.distance) { return -1; }
                            return 0;
                        });
                        // sort shop isOpen then distance end

                        app.myListShopDisplayInit();                        

                        if (app.info.order_temp_info.home_select_shop != "") {
                            // check home select shop
                            app.checkHomeSelectShop();
                        }
                        else if (app.info.order_temp_info.temp_default_shop != "") {
                            // check temp default shop for direct to menu
                            app.checkOrderTempDefaultShop();
                        }
                        else {
                            // check shop is online
                            app.checkOrderShopIsOpen();
                            app.info.loading = false;
                        }
                    }
                }
            },

            getShopStatus(shop) {
                //console.log("shop.quoteTime", shop.quoteTime)
                if (!shop.isOpen) return "closed";
                // if (shop.quoteTime >= 60) return "verybusy";
                // if (shop.quoteTime >= 40) return "busy";
                if (shop.quoteTime >= 0) return "normal";
                return "offline";
            },
            goBack() {
                if (this.currentShop == undefined) return false;
                this.currentShop = undefined;
                return true;
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            getShopIcon(item) {
                return `/files/images/ico_shop_${item.code}.png`;
            },
            
            /*
            openShop(shop) {
                this.currentShop = shop;
                if (this.currentShop.isCloseSoon) {
                    var time = this.cart.getShopCloseTime(this.currentShop, this.$root.OrderDateSelectIsHoliday);
                    if (time.length == 4) {
                        time = moment(
                            "2000-01-01 " + time.substr(0, 2) + ":" + time.substr(2, 2)
                        )
                            .add(this.$root.serverTimeDiff, "ms")
                            .add("minute", -this.currentShop.quoteTimeList[0])
                            .format("HH:mm");
                    }
                    this.$root.alert(
                        this.label["shop_will_close_soon"].replace(/#time#/g, time)
                    );
                }

            },
            */
            selectShop(shop, isReplace) {
                if (isReplace == null) isReplace = false;

                var app = this;
                if (shop.isOpen) {
                    this.currentShop = shop;
                    //console.log("selectShop", this.currentShop);
                    if (this.currentShop == undefined) return;
                    if (!this.currentShop.isOnline || !this.currentShop.isOpen) return;

                    //console.log("this.cart", this.cart);
                    if (this.cart.token != "" && this.cart.member != null) {

                        if (this.info.order_temp_info.order_address_type == "search") {
                            this.$root.FillMemberInfoToOrderContactInfo();
                            this.$root.setOrderTempInfoData();
                        }
                        //this.$root.createGuestLogin(this.cart.member.name, this.cart.member.phone);       
                    }
                    else {
                        // get new token before select shop
                        if (this.cart.token == "") {
                            this.$root.createGuestLogin("GUEST", "99999999");
                        }
                    }


                    //this.cart.shop = this.currentShop;
                    //this.$root.SetOrderShopMenuTime();
                    //this.$root.setOrderTempInfoData();
                    //this.cart.updateCartOrderInfo(this.info.order_temp_info, this.info.lang);
                    //this.cart.saveCart();

                    //this.$root.setSelectShop(this.currentShop);
                    //this.$router.push("menu");
                    
                    app.$root.setSelectShopCheckReOrder(app.currentShop, function () {

                        // set home select value and update cart value for safe
                        if (app.$root.getCurrentOrderTypeShopFilterSubfix != '3') {
                            if (app.currentShop.districtCode != "") {
                                //app.$root.homeSelectShop.homeSelectShopArea = app.currentShop.areaCode;
                                //app.$root.homeSelectShop.homeSelectShopDistrict = app.currentShop.districtCode;

                                if (!app.$root.CheckOrderModeIsShopping) {
                                    app.cart.shopArea = app.currentShop.areaCode;
                                    app.cart.shopDistrict = app.currentShop.districtCode;
                                }
                                else {
                                    app.cart.shopArea = null;
                                    app.cart.shopDistrict = null;
                                }                                
                            }
                            else {
                                app.cart.shopArea = app.$root.homeSelectShop.homeSelectShopArea;
                                app.cart.shopDistrict = app.$root.homeSelectShop.homeSelectShopDistrict;
                            }
                        }

                        // check shop and get the shop bufferTime
                        if (app.$root.checkShopCodeIsActiveAsync(app.currentShop.shopCode_global)) {
                            app.cart.shop = app.currentShop;
                            app.$root.UpdateCartShopInfo(app.cart.shop);
                            app.$root.SetOrderShopMenuTime();
                            app.$root.setOrderTempInfoData();
                            app.cart.updateCartOrderInfo(app.info.order_temp_info, app.info.lang);
                            app.cart.saveCart();

                            if (isReplace) {
                                app.$router.replace("menu");
                            }
                            else {
                                app.$router.push("menu");
                            }
                        }
                        else {
                            app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                            app.$router.replace('/');
                        }

                    });
                }
                else {
                    app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                    app.$router.replace('/');
                }
            },
            likeShopClick(shop) {
                var app = this;
                var temp_myLikeShop = window.localStorage.getItem("myLikeShop") || "[]";
                app.myLikeShop = JSON.parse(temp_myLikeShop);

                var shop_arr = [shop.shopCode.substring(0, shop.shopCode.length - 2) + "_1", shop.shopCode.substring(0, shop.shopCode.length - 2) + "_2"];
                $.each(shop_arr, (i, s) => {
                    var like_shop_idx = app.myLikeShop.indexOf(s);
                    if (like_shop_idx >= 0) {
                        app.myLikeShop.splice(like_shop_idx, 1);
                    }
                    else {
                        app.myLikeShop.push(s);
                    }
                });

                //app.myListShopDisplayInit();
                window.localStorage.setItem("myLikeShop", JSON.stringify(app.myLikeShop));

            },
            myListShopDisplayInit() {
                var app = this;
                app.myListShopDisplay = [];
                $.each(app.shopList, (i, s) => {
                    if (app.myLikeShop.indexOf(s.shopCode) >= 0) {
                        app.myListShopDisplay.push(s);
                    }
                });
            },
            likeShopCheck(s) {
                if (this.myLikeShop.indexOf(s.shopCode) >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            }, 

            checkOrderTempDefaultShop() {
                var app = this;
                if (app.info.order_temp_info.temp_default_shop != "") {
                    //console.log("app.shopList", app.shopList);
                    var temp_shop = app.shopList.filter(s => (s.shopCode_global == app.info.order_temp_info.temp_default_shop));
                    //console.log("temp_shop", temp_shop);
                    if (temp_shop.length > 0) {
                        if (temp_shop[0].isOpen) {
                            app.selectShop(temp_shop[0], true);
                            //app.info.order_temp_info.temp_default_shop = "";
                            //app.$root.GetDefaultShopCodeObj();
                            //app.$root.setOrderTempInfoData();
                        }
                        else {
                            app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                            app.$router.replace('/');
                        }
                    }
                    else {
                        app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                        //app.info.order_temp_info.temp_default_shop = "";
                        //app.$root.GetDefaultShopCodeObj();
                        //app.$root.fixHomeOptionObj.isFix = false;
                        //app.$root.setOrderTempInfoData();

                        // not clear default_shop and redirect to home
                        app.$router.replace('/');
                    }

                }
            },
            checkOrderShopIsOpen() {
                var app = this;
                var temp_shop = app.shopList.filter(s => (s.isOpen == true));
                if (temp_shop.length > 0) { }
                else {
                    app.$root.alert("shop_current_not_available_text");
                    app.$router.replace('/');
                }
            },

            checkHomeSelectShop() {
                var app = this;
                if (app.info.order_temp_info.home_select_shop != "") {
                    var temp_shop = app.shopList.filter(s => (s.shopCode == app.info.order_temp_info.home_select_shop));
                    if (temp_shop.length > 0) {
                        if (temp_shop[0].isOpen) {
                            app.selectShop(temp_shop[0], true);
                        }
                        else {
                            app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                            app.$router.replace('/');
                        }
                    }
                    else {
                        app.$root.alert("shop_list_cannot_find_shop_or_shop_no_online");
                        app.$router.replace('/');
                    }

                }
            },

        }
    };
</script>

